(/**
 * Initializes and configures Algolia instant search functionality for the `products` index.
 *
 * This function sets up the Algolia search client and configures a custom rendering order for the facet `inventory_available`.
 * The instant search is configured to use the `products` index from Algolia and the functionality is invoked on the `DOMContentLoaded` event.
 *
 * @param {Object} algolia - An object containing Algolia configuration details such as `app_id` and `index_prefix`.
 *
 * @property {Object} algolia.config - The configuration object containing index prefix and application ID.
 * @property {string} algolia.config.app_id - The application ID used to initialize Algolia search.
 * @property {string} algolia.config.index_prefix - The prefix for constructing the index name.
 *
 * @returns {void} This function does not return a value.
 */
async function (algolia) {
    let instantsearch = window.instantsearch;
    let algoliasearch = window.algoliasearch.algoliasearch;
    let indexName = algolia.config.index_prefix + 'products';

    algolia.searchClient = algoliasearch(
        algolia.config.app_id,
        '43573aa89c39385d581c0d4b97bc0fac'
    );

    document.addEventListener('DOMContentLoaded', function () {
        window.search = instantsearch({
            indexName: indexName,
            searchClient: algolia.searchClient
        });

        algolia.searchClient.setSettings(
            {
                indexName: indexName,
                indexSettings: {
                    renderingContent: {
                        facetOrdering: {
                            facets: {
                                order: ['inventory_available'],
                            },
                            values: {
                                "inventory_available": {
                                    "order": ["true"],
                                    "hide": ["false"]
                                },
                            },
                        },
                    },
                }
            })
            .then(() => {
                // done
            });

        window.search.start();
    });

})(window.algoliaShopify);

